// translate-status.pipe.ts

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translateStatus',
  standalone: true,
})
export class TranslateStatusPipe implements PipeTransform {

  transform(value: string): string {
    switch(value) {
      case 'processed':
        return 'E-Mail verschickt';
      // we need to handle partly payments by showing the amount
      case 'partial':
        return 'Teilzahlung';
      case 'paid':
        return 'Rechnung bezahlt';
      case 'click':
        return 'Online Zahlung gestartet';
      case 'download':
        return 'Rechnung heruntergeladen';
      case 'delivered':
        return 'E-Mail zugestellt';
      case 'open':
        return 'E-Mail geöffnet';
      case 'reminded':
        return 'Zahlungserinnerung gesendet';
      case 'reject':
      case 'bounce':
        return 'E-Mail Zustellung fehlgeschlagen';
      default:
        return value; // Return the input value if it doesn't match any of the cases
    }
  }

}
